import * as React from 'react';
import { SwitchHandleStyled, SwitchStyled } from './switch.component.style';
export const Switch = (props) => {
    const handleClick = () => {
        props.onChange(!props.checked, props.id);
    };
    return (React.createElement(SwitchStyled, { "aria-pressed": props.checked, "$checked": props.checked, disabled: props.disabled, onClick: handleClick },
        React.createElement(SwitchHandleStyled, { "$checked": props.checked })));
};
